import servidorApi from '../api/ServidorApi';

class ServidorService {

    private servidorApi = servidorApi;

    async buscarServidoresPJe(orgao) {
        return await this.servidorApi.buscarServidoresPJe(orgao);
    }

    async buscarServidoresPJeSecretarias(descricaoLocalizacao) {
        return await this.servidorApi.buscarServidoresPJeSecretarias(descricaoLocalizacao);
    }

    async buscarInformacoesUsuario(cpfUsuario) {

        //FIXME retirar este if após conclusão da issue 
        if (cpfUsuario && cpfUsuario.trim() === 'FAKE') {
            return;
        }
        return await this.servidorApi.buscarInformacoesUsuario(cpfUsuario);
    }

    async buscarOrgaoJulgador(localizacao) {
        return await this.servidorApi.buscarOrgaoJulgador(localizacao)
    }

    // async msConsultaUsuarios(cpfUsuario, p0?: { silent: boolean; }) {
    //     try {
    //         const resultado = await this.servidorApi.msConsultaUsuarios(cpfUsuario, { silent: true });
    //         return resultado;
    //     } catch (erro) {
    //         // console.warn(`CPF não encontrado ou erro na consulta: ${cpfUsuario}`, erro);
    //         return null;
    //     }
    // }    

    async msConsultaUsuarios(cpfs: string[]) {
        try {
            const resultado = await this.servidorApi.msConsultaUsuariosBatch(cpfs, { silent: true });
            return resultado;
        } catch (_erro) {
            // console.warn(`CPF não encontrado ou erro na consulta: ${cpfUsuario}`, erro);
            return null;
        }
    }
}

export default new ServidorService();